// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"695":"b09738d6","974":"694ea54f","993":"14254ad5"}[chunkId] + ".chunk.css";
};